import { RequestError } from "../requestError";
import api from "../axiosBase";
import { getURL } from "../serviceHelper";
import { getEnv } from "../../AppConfigs";

const SPSiteId = getEnv("REACT_APP_SP_SITE_ID");
const SPListId = getEnv("REACT_APP_DOCUMENT_TYPES_LIST_ID");

const expand =
  "expand=fields(select=id,Title)";

export class DocumentTypeService {
  static async getList() {
    const url = `/sites/${SPSiteId}/lists/${SPListId}/items?${expand}`;;
    return api
      .get(getURL(url))
      .then((res) => {
        return res.data.value.map((item: any) => (DocumentTypeService.mapData(item)));
      })
      .catch((err) => {
        throw new RequestError(err);
      });
  }

  static async getDetails(id: number) {
    const url = `/sites/${SPSiteId}/lists/${SPListId}/items?${expand}&$filter=id eq ${id}`;

    return api
      .get(getURL(url))
      .then((res) => {
        console.log(res);
      })
      .catch((err) => {
        throw new RequestError(err);
      });
  }

  static async create(fields: any) {
    return api
      .post(
        getURL(`/sites/${SPSiteId}/lists/${SPListId}/items`),
        { fields }
      )
      .then((res) => this.mapData(res.data))
      .catch((err) => {
        throw new RequestError(err);
      });
  }

  static async update(id: any, fields: any) {
    return api
      .patch(
        getURL(`/sites/${SPSiteId}/lists/${SPListId}/items/${id}/fields`),
        fields
      )
      .then((res) => res.data)
      .catch((err) => {
        throw new RequestError(err);
      });
  }

  static async delete(id: any, listId?: string) {
    return api.delete(getURL(`/sites/${SPSiteId}/lists/${SPListId}/items/${id}`))
      .then(res => res.data,)
      .catch(err => { throw new RequestError(err) });
     
  }

  static mapData(item: any) { 
    return {
      value: item.id,
      label: item.fields.Title
    }
  }
}
